import { computed } from 'vue';
import { useUserStore } from '@/store/useUserStore';
import { useSmartActionsStore } from '@/modules/viewer/store/useSmartActionsStore';

/**
 * Composable to generate the AI processing message.
 * @returns A computed ref with the processing message string.
 */
export function useAiProcessingMessage() {
  const userStore = useUserStore();
  const smartActionsStore = useSmartActionsStore();

  return computed<string>(() => {
    const setting = userStore.smartActionSetting;
    const settingType = userStore.smartActionSettingType;

    const humanReadable = (text: string): string =>
      text
        .split('_')
        .map(w => w.charAt(0).toUpperCase() + w.slice(1))
        .join(' ');

    const defaultMessage = "We're working on a General Summary";
    const noSummary = 'No summary will be generated';
    const choosingMessage = 'Zight is choosing the best AI smart action';
    const smartMsg = (type: string) => `We're working on a new AI summary using the smart action: ${humanReadable(type)}`;
    const actionType = smartActionsStore.actionType;

    if (actionType && actionType.trim()) {
      return smartMsg(actionType);
    }

    switch (setting) {
      case 'never':
        return noSummary;

      case 'not_edited':
        return defaultMessage;

      case 'chosen_smart_action':
        return settingType ? smartMsg(settingType) : defaultMessage;

      case 'zight_smart_action':
        return choosingMessage;

      default:
        return defaultMessage;
    }
  });
}
